@if (pageHeaderComponent()) {
  <div uipageheader *ngComponentOutlet="pageHeaderComponent()"></div>
} @else {
  <div uipageheader>
    <ng-content select="[uipageheader]"></ng-content>
  </div>
}
@if (pageContentComponent()) {
  <div
    uipagecontent
    *ngComponentOutlet="pageContentComponent(); inputs: pageContentInput()"
  ></div>
} @else {
  <div uipagecontent uianchorhost>
    <ng-content select="[uipagecontent]"></ng-content>
  </div>
}
